<template>
  <div class="page-content">
    <LocationsComponent />
  </div>
</template>

<script>
import LocationsComponent from '../components/LocationsComponent.vue'

export default {
  name: 'Locations',
  components: {
    LocationsComponent
  }
}
</script>

<style scoped>
.page-content {
  flex: 1;
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
